<template>
    <div class="c-header-dark" style="position:fixed;width:100vw;z-index:5;" role="banner">
        <div class="c-header__inner">

            <div class="c-logo"> <!-- logo-container -->
                <img class="c-logo--small" src="../../assets/style/ckm-style/images/blbglogo.png" /> <!-- logo -->
            </div>

            <div class="c-header__nav-container js-nav-panel">
                <ul class="c-primary-nav__list-left js-nav-panel" role="tablist" aria-multiselectable="true"> <!-- tab list -->
                    <li class="c-primary-nav__item">
                        <router-link
                            to="/"
                            tag="a"
                            class="c-primary-nav__link"
                            data-cy="homeHeader"
                            exact
                        >
                            <span class="c-primary-nav__text">
                                HOME
                            </span>
                        </router-link>
                    </li>

                    <li class="c-primary-nav__item">
                        <router-link
                            :to="`/lossCalculator`"
                            tag="a"
                            class="c-primary-nav__link"
                            exact
                        >
                            <span class="c-primary-nav__text">
                                LOSS CALCULATOR
                            </span>
                        </router-link>
                    </li>
                    <li class="c-primary-nav__item">
                        <router-link
                            :to="`/createNewCase`"
                            tag="a"
                            class="c-primary-nav__link"
                            exact
                        >
                            <span class="c-primary-nav__text">
                                CREATE NEW CASE
                            </span>
                        </router-link>
                    </li>
                </ul>
                    <side-menu />
            </div>
        </div>
    </div>
</template>

<script>
import SideMenu from '@Common/SideMenu.vue'

export default {
    components: {
        sideMenu: SideMenu
    },
    computed: {
        selectedAccountName () {
           return this.$store.state.selectedAccountName
        },
        selectedAccountId(){
            return this.$store.state.selectedAccountId
        }
    }
}
</script>


<style src="@Style/header.css"></style>
